import React, { useState } from 'react';
import get from 'lodash/get';
import {
  Spin,
  Button,
  Drawer,
  Modal,
  Input,
  Form,
  message,
  notification,
} from 'antd';
import { useDispatch } from 'react-redux';
import { LeftOutlined } from '@ant-design/icons';
import { salesChannelManagement } from '../../../redux/actions/marketPlaceAction';
import ShopifyDetails from './shopifyDetails';
import {
  CONNECTION_FAILED,
  CONNECTION_SUCCESS,
} from '../../../constants/messages';

const ShopifyIntegration = (props) => {
  const { shopifyChannel, selectedCompany } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [shopifyDetails, setShopifyDetails] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [viewDrawer, setViewDrawer] = useState(false);

  const toggleViewDrawer = () => {
    setViewDrawer(!viewDrawer);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
  };

  const fetchShopifyDetails = () => {
    setLoading(true);
    dispatch(
      salesChannelManagement('get.connection', {
        company_id: get(selectedCompany, 'id'),
        id: get(shopifyChannel, 'Connection.id'),
      })
    )
      .then((result) => {
        setLoading(false);
        setShopifyDetails(get(result, 'data'));
        if (get(shopifyDetails, 'is_active')) {
          toggleViewDrawer();
        } else {
          notification.error({
            message: CONNECTION_FAILED,
          });
          toggleModal();
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const setupShopifyConnection = (values) => {
    setLoading(true);
    dispatch(
      salesChannelManagement('channel_setup', {
        company_id: get(selectedCompany, 'id'),
        channel: 'SHOPIFY',
        ...values,
      })
    )
      .then((result) => {
        setLoading(false);
        message.success(CONNECTION_SUCCESS);
        window.location.replace(get(result, 'data.auth_url'));
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const onFinishFailed = () => {};

  return (
    <Spin spinning={loading}>
      <div>
        <Button
          className="channel-btn"
          onClick={() =>
            get(shopifyChannel, 'is_configured')
              ? fetchShopifyDetails()
              : toggleModal()
          }
        >
          <img
            src={get(shopifyChannel, 'image')}
            alt=""
            className="width-100"
          />
        </Button>
        <div className="mt-10 text-center">{get(shopifyChannel, 'name')}</div>
      </div>

      <Drawer
        title={`${get(shopifyChannel, 'name')} Integration`}
        destroyOnClose
        placement="right"
        width="40%"
        open={viewDrawer}
        onClose={toggleViewDrawer}
      >
        <ShopifyDetails
          channel={shopifyChannel}
          shopifyDetails={shopifyDetails}
          selectedCompany={selectedCompany}
          toggleViewDrawer={toggleViewDrawer}
        />
      </Drawer>

      <Modal
        width="37%"
        destroyOnClose
        className="common-modal product-image-modal"
        closable={false}
        open={showModal}
        onOk={toggleModal}
        onCancel={toggleModal}
        footer={false}
        maskClosable={false}
      >
        <Spin spinning={loading}>
          <div className="login-container" style={{ boxShadow: 'none' }}>
            <div className="heading">
              <LeftOutlined
                className="back-btn"
                onClick={() => {
                  toggleModal();
                }}
              />
              Connect to {get(shopifyChannel, 'name')}
            </div>

            <Form
              name="basic"
              layout="vertical"
              onFinish={setupShopifyConnection}
              onFinishFailed={onFinishFailed}
              autoComplete="off"
              requiredMark={false}
            >
              <Form.Item
                name="shop"
                rules={[
                  {
                    required: true,
                    message: 'Please enter the shop url',
                  },
                  {
                    min: 1,
                    message: 'Shop url cannot be less than 1 character',
                  },
                  {
                    max: 200,
                    message: 'Shop url cannot be more than 200 characters',
                  },
                ]}
                className="mt-40"
              >
                <Input addonBefore="https://" addonAfter=".myshopify.com" />
              </Form.Item>

              <div className="mt-40">
                <Form.Item>
                  <Button type="primary" htmlType="submit" block>
                    Confirm
                  </Button>
                </Form.Item>
              </div>
            </Form>
          </div>
        </Spin>
      </Modal>
    </Spin>
  );
};

export default ShopifyIntegration;
